import React, { useEffect, useRef, useState } from 'react'
import { useParticipantsByDayList } from './hooks'
import { Flex, InputRef, Table } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { CButton, CCardBody } from '@coreui/react-pro'
import { ParticipantByDay } from './types'
import { getColumnSearchProps } from '../../../../libs/tableFunctions'
import { FilterValue } from 'antd/es/table/interface'
import { path } from '../../../../libs'
import { Link } from 'react-router-dom'
import { TicketsModal } from '../widgets/ticketsModal/component'

export const Ramadan2026CompetitionsDetails: React.FC = () => {
  const {
    participantsByDay,
    loading,
    totalCountOfParticipantsByDay,
    participantsByDayStatistic,
    onChangeParticipantsByDay,
  } = useParticipantsByDayList()

  const [searchText, setSearchText] = useState<{
    [key: string]: string
  }>({})
  const [orderBy, setOrderBy] = useState('')
  const [orderDirection, setOrderDirection] = useState('-')
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [filtersState, setFiltersState] = useState<
    Record<string, FilterValue | null>
  >({})

  const searchInput = useRef<InputRef>(null)

  const handleTableChange = ({
    currentPage,
    currentPageSize,
    currentOrderBy,
    currentOrderDirection,
    filters,
  }: {
    currentPage?: number
    currentPageSize?: number
    currentOrderBy?: string
    currentOrderDirection?: string
    filters?: Record<string, FilterValue | null>
  }) => {
    if (currentPage) {
      setPage(currentPage)
    }
    if (currentPageSize) {
      setPageSize(currentPageSize)
    }
    if (currentOrderBy) {
      setOrderBy(currentOrderBy)
    }
    if (currentOrderDirection) {
      if (currentOrderDirection == 'descend') {
        setOrderDirection('-')
      } else {
        setOrderDirection('')
      }
    }

    if (filters) {
      setFiltersState(filters)
    }
  }

  useEffect(() => {
    onChangeParticipantsByDay({
      limit: pageSize,
      page: page,
      orderBy: orderBy,
      orderDirection: orderDirection,
      searchText: searchText,
      filters: filtersState,
    })
  }, [pageSize, page, orderBy, orderDirection, searchText, filtersState])

  const columns: ColumnsType<ParticipantByDay> = [
    {
      title: 'ID',
      dataIndex: ['client', 'clientId'],
      defaultSortOrder: 'descend',
      ...getColumnSearchProps<ParticipantByDay>(
        'client.clientId',
        setSearchText,
        searchText,
        searchInput,
      ),
      render: (id) => (
        <Link to={path.clients.details(id)} style={{ textDecoration: 'none' }}>
          {id}
        </Link>
      ),
    },
    {
      title: 'Full name',
      dataIndex: ['client', 'fullName'],
      ...getColumnSearchProps<ParticipantByDay>(
        'client.fullName',
        setSearchText,
        searchText,
        searchInput,
      ),
    },
    {
      title: 'Email',
      dataIndex: ['client', 'email'],
      ...getColumnSearchProps<ParticipantByDay>(
        'client.email',
        setSearchText,
        searchText,
        searchInput,
      ),
    },
    {
      title: 'Country',
      dataIndex: ['client', 'country'],
      ...getColumnSearchProps<ParticipantByDay>(
        'client.country',
        setSearchText,
        searchText,
        searchInput,
      ),
    },
    {
      title: 'Lots',
      dataIndex: 'lots',
      sorter: true,
    },
    {
      title: 'Tickets',
      dataIndex: 'tickets',
      sorter: true,
      render: (item) => {
        return (
          <div className="d-flex gap-2">
            {item ? (
              <TicketsModal buttonName={item?.length} tickets={item} />
            ) : (
              'no tickets'
            )}
          </div>
        )
      },
    },
  ]

  return (
    <CCardBody>
      <Flex className="mb-3" gap={5} vertical>
        <div>
          <strong>Trader winner: </strong>
          <Link
            to={path.clients.details(
              String(participantsByDayStatistic.traderWinner?.id),
            )}
            style={{ textDecoration: 'none' }}
          >
            {participantsByDayStatistic.traderWinner?.fullName}
          </Link>
        </div>
        <div>
          <strong>Ruffle Winner: </strong>
          <Link
            to={path.clients.details(
              String(participantsByDayStatistic.ruffleWinner?.id),
            )}
            style={{ textDecoration: 'none' }}
          >
            {participantsByDayStatistic.ruffleWinner?.fullName}
          </Link>
        </div>
        <div>
          <strong>Winning ticket: </strong>
          {participantsByDayStatistic?.winningTicket}
        </div>
      </Flex>
      <Table
        dataSource={participantsByDay}
        bordered={true}
        scroll={{ x: true }}
        loading={loading}
        rowKey="participantsByDayId"
        columns={columns}
        pagination={{
          showSizeChanger: true,
          total: totalCountOfParticipantsByDay,
        }}
        onChange={(pagination, filters, sorter) =>
          handleTableChange({
            //@ts-ignore
            currentPage: pagination.current, //@ts-ignore
            currentPageSize: pagination.pageSize, //@ts-ignore
            currentOrderDirection: sorter.order, //@ts-ignore
            currentOrderBy: sorter.field,
            filters,
          })
        }
      />
    </CCardBody>
  )
}
